import { render, staticRenderFns } from "./DashboardNotPerformedAudits.vue?vue&type=template&id=deab490c"
import script from "./DashboardNotPerformedAudits.vue?vue&type=script&lang=ts"
export * from "./DashboardNotPerformedAudits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports